var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderMapPin = function SvgHeaderMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.17 0A10.34 10.34 0 0 0 .83 10.34c0 3.82 4.33 12.07 7.97 18.3a2.73 2.73 0 0 0 4.74 0c6.6-11.32 7.96-16.22 7.96-18.3C21.5 4.64 16.9 0 11.17 0Zm.31 27.47a.35.35 0 0 1-.31.2.35.35 0 0 1-.32-.2C6.05 19.25 3.2 12.83 3.2 10.34a7.97 7.97 0 0 1 15.93 0c0 2.5-2.84 8.91-7.65 17.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.17 5.18a5.15 5.15 0 1 0 0 10.31 5.15 5.15 0 0 0 0-10.3Zm0 7.94a2.77 2.77 0 0 1-2.79-2.78 2.77 2.77 0 0 1 2.79-2.78 2.77 2.77 0 0 1 2.78 2.78 2.77 2.77 0 0 1-2.78 2.78Z"
  })));
};
export default SvgHeaderMapPin;